import { OrderSalaryCardType } from 'store/types/salaryCard';
import { secureLocalStorageGet } from '../../helpers/index'
import { http } from '../http'

function userGWFragments() {
    const userData = secureLocalStorageGet('userData');
    const { customerNo } = userData.customerData.find(customer => customer.favorite === 'Y')

    return { customerNo, language: localStorage.getItem("i18nextLng")?.toUpperCase() }
}

export const fetchBusinessCardsService = async (currency: string): Promise<any[]> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/cards/by-currency',
      inqTypeCode: null,
      data: {
        ...userFragments,
        currency,
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message)
  }

  return data.data.data
}

export const fetchOrderNoInfoService = async (): Promise<any> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/configs',
      data: {
        ...userFragments,
        orderType:"SCO",
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message)
  }

  return data.data.data
}

export const fetchCreateSalaryCardService = async (req: OrderSalaryCardType): Promise<any> => {
  const userFragments = userGWFragments()

  const { data } = await http.post<any>(
    `gateway/${userFragments.customerNo}/inquiry`,
    {
      url: '/ib/order/card/salary/create',
      data: {
        ...userFragments,
        ...req
      },
    }
  )

  if (data.data.code !== 200) {
    throw new Error(data.data.message)
  }

  return data.data.data
}
